export const environment = {
	production: false,
	// api donde se desplega qa: cobranzadigital-qa.apps.ambientesbc.com
	apiEndPointCobranza: "https://alternativafinanciera-qa.apps.ambientesbc.com",
	// URL_BASE a la cual pegan los servicios - dependiendo del ambiente
	urlServices:
		"https://filialesexterior-ext-qa.apps.ambientesbc.com/cobranza-digital/ms-edge",
	environment: "certification",
  urlMaintenance_info: "https://filialesexterior-ext-qa.apps.ambientesbc.com",
  urlDynatreceSessionReplay: "https://js-cdn.dynatrace.com/jstag/188d956ec0f/bf93684wuh/f539380acf667e1e_complete.js",
  diasHabiles: '#{DIAS_HABILES}#'
};
